<template>
  <img class="rounded-image rounded-circle" :class="{ scaled: scale }" :src="imageSrc" :alt="name">
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    image: { type: Object, required: true },
    height: { type: Number, required: false, default: 200 },
    scale: { type: Boolean, required: false, default: false }
  },

  computed: {
    imageSrc() {
      return this.image.image_server_base_path + '/' + this.image.filename + '/full/,' + this.height + '/0/default.jpg'
    }
  }
}
</script>

<style lang="scss" scoped>
  .rounded-image.scaled {
    transform: scale(1);
    -moz-transform: scale(1); 
    -webkit-transform: scale(1); transform: scale(1);
    transition:0.7s ease all; 
    -webkit-transition:0.7s ease all; 
    -moz-transition:0.7s ease all;
    
    &:hover {
      transform: scale(1.2);
      -moz-transform: scale(1.2); 
      -webkit-transform: scale(1.2); 
    }
  }
</style>